module.exports = __webpack_public_path__ + "img/dab_sedziwy.71305035.jpg";